import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import targetComponent from 'components/trainer/StudentArea';
import trainerActions from 'actions/trainerActions';

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  return {
    user: appState.session.user!,
    trainer: appState.trainer,
    ...ownProps,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {
  return {
    ...stateProps,
    fetchData: (student_id: number) => {
      dispatch(trainerActions.fetchStudent({ student_id }))
    },
    getStudent: (student_id: number) => {
      const student = stateProps.trainer.student
      if (student.student_id !== student_id) {
        return null
      }
      return student.record
    },
    getStudyTimeStats: (student_id: number) => {
      const stats = stateProps.trainer.studyTimeStats
      if (stats.student_id !== student_id) {
        return null
      }
      return stats
    },
    fetchNextStudyTimeStats: () => {
      dispatch(trainerActions.fetchStudentNextStudyTimeStats())
    },
    fetchStudyAchievementsLatest: (student_id: number) => {
      const student = stateProps.trainer.student
      if (student.student_id !== student_id) {
        return null
      }
      dispatch(trainerActions.fetchTrainerStudyAchievementsLatest({ params: { student_id: student_id }}))
    }
  }
}

type connectMappedProps = ReturnType<typeof mergeProps>
export type mappedProps = connectMappedProps

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(targetComponent))